export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
// Detección automática de entorno local (localhost) vs producción
const esLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const URL_API = process.env.REACT_APP_API_URL || (esLocal ? 'http://localhost:1337/api' : 'https://consultas-api.vitaliatec.com/api');

